export default __webpack_public_path__ + "static/media/1_banner-consultoria.9a4893af.jpg";